import $ from 'jquery'

export default {
  show: ->
    $('.loading').show()

  hide: ->
    $('.loading').hide()
}
